export default {
  namespaced: true,
  state: {
    gamesList: [],
    tasksList: [],
    actualGamesCount: 0,
    points: 18300, // Заработанные баллы
    progressWidth: 20,
    // тестовые данные для вёрстки
    statuses: [
      { name: '0 %', from: 0, percent: '0' },
      { name: 'Минимальный 0.5%', from: 3000, percent: '0.5%' },
      { name: 'Базовый 2.5%', from: 10000, percent: '2.5%' },
      { name: 'Увеличенный 4.5%', from: 10100, percent: '4.5%' },
    ],
    isMobile: window.innerWidth < 576,
    openedPlans: [],
  },
  actions: {
    ConfirmAction({ dispatch, rootGetters }, payload) {
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('/tasks/api/task/take-part', {
          profile_id: payload.profile_id,
          task_id: payload.task_id,
        })
          .then(() => {
            dispatch('GetTasksList', { profile_id: payload.profile_id });
            // dispatch('GetActiveActionsList', { profile_id: payload.profile_id });
            // resolve(response);
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetGamesList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'actualGamesCount', value: 0 });
      commit('setField', { name: 'gamesList', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('tasks/api/task/plans-list', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'actualGamesCount', value: response.data.plans.length });
              commit('setField', { name: 'gamesList', value: response.data.plans });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    GetTasksList({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'actualTasksCount', value: 0 });
      commit('setField', { name: 'tasksList', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.axl.post('tasks/api/task/tasks-list', payload)
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'actualTasksCount', value: response.data.tasks.length });
              commit('setField', { name: 'tasksList', value: response.data.tasks });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreGames({ commit }) {
      commit('setField', { name: 'actualGamesCount', value: 0 });
      commit('setField', { name: 'gamesList', value: [] });
      commit('setField', { name: 'actualTasksCount', value: 0 });
      commit('setField', { name: 'tasksList', value: [] });
    },
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined || value === '') {
        return '—';
      }
      const numValue = Number(value);
      if (Number.isNaN(numValue) || !Number.isFinite(numValue)) {
        return '—';
      }
      const formatted = numValue.toLocaleString('ru-RU');
      return `${formatted} руб`;
    },
    formatPercent(value) {
      if (value === null || value === undefined || value === '') {
        return '—';
      }
      const numValue = Number(value);
      if (Number.isNaN(numValue) || !Number.isFinite(numValue)) {
        return '—';
      }
      if (Number.isInteger(numValue)) {
        return `${numValue}%`;
      }
      try {
        return `${numValue.toFixed(1)}%`;
      } catch (e) {
        console.warn('Ошибка форматирования процента:', e, value);
        return '—';
      }
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
